function GlossaryScript() {

    
    const self = this;
    let activeLetter = 'ltr-all';


    function initSorting() {
        const select = document.getElementById('glossarch_cats_sort');
        if (!select) {
            return false;
        }
        const postsWrp = document.getElementById('glossarch_list');
        let sortNamesObject = {};
        let sortNames = [];
        for (const it of document.querySelectorAll('.glossarch_list_item')) {
            const sortingAttr = it.getAttribute('data-sort');
            if (sortingAttr) {
                const sortingAttrObj = JSON.parse(sortingAttr);
                if (sortingAttrObj.name) {
                    sortNamesObject[sortingAttrObj.name] = it;
                    sortNames.push(sortingAttrObj.name);
                }
            }
        }
        let currentSelectedValue = 1;
        select.addEventListener('change', function(el) {
            const sValue = parseInt(select.value);
            if (sValue == currentSelectedValue) {
                return false;
            }
            currentSelectedValue = sValue;
            switch (sValue) {
                case 1:
                    sortNames.sort();
                    break;
                case 2:
                    sortNames.sort().reverse();
                    break;
            }
            postsWrp.innerHTML = '';
            for (const postName of sortNames) {
                postsWrp.appendChild(sortNamesObject[postName]);
            }
        });
    }


    function initLettersFilter() {
        const select = document.getElementById('glossarch_cats_ltrs');
        if (!select) {
            return false;
        }
        select.addEventListener('change', function(el) {
            activeLetter = select.value;
            filterItems();
        });
    }


    function filterItems() {
        for (const it of document.querySelectorAll('.glossarch_list_item')) {
            if (
                it.classList.contains(activeLetter)
            ) {
                it.classList.remove('is-hidden');
            } else {
                it.classList.add('is-hidden');
            }
        }
    }


    self.run = function() {
        initLettersFilter();
        initSorting();
    }

}

const join_glossary_js = new GlossaryScript();
join_glossary_js.run();